<template>
  <v-sheet
    class="mx-auto"
    elevation="0"
    rounded="0"
    min-width="140"
    color="#F7F8FA"
  >
    <v-sparkline
      auto-draw
      :labels="labels"
      :model-value="values"
      color="primary"
      line-width="2"
      padding="16"
      :show-labels="false"
    ></v-sparkline>
  </v-sheet>
</template>


<script>
import { AdPlacementAPIInstance } from "@/api";
import moment from "moment";

export default {
  components: {},
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["onDetails"],
  data() {
    return {
      labels: this.getHourlyLabelsFromPast12Hours(),
      values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Placeholder for hourly clicks
    };
  },

  created() {
    this.getAnalytics();
  },
  methods: {
    getHourlyLabelsFromPast12Hours() {
      const now = moment();
      const start = moment().subtract(12, "hours").startOf("hour");
      const labels = [];

      while (start.isBefore(now)) {
        labels.push(start.format("ha")); // e.g., "10am", "11am"
        start.add(1, "hour");
      }

      return labels;
    },
    async getAnalytics() {
      const { data } = await AdPlacementAPIInstance.Analytics.hourlyIdle(
        this.value.id
      );

      if (data && data.length > 0) {
        this.values = this.labels.map((label) => {
          const hourData = data.find(
            (item) => moment(item.date).format("ha") === label
          );
          return hourData ? hourData.count : 0;
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.ad-type-img-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>